import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { API_PATH } from 'src/environments/environment';
import { FrontFirstTreeResponse } from 'src/app/shared/components/front-first-permission-tree/front-first-permission-tree.types';
import { AbstractCrudService } from '../../../shared/components/crud/abstract-crud.service';
import { RELATIVE_URL } from './plan-permissions-config';

/** Folha do catálogo do plano (raw, formato devolvido pela API — inalterado). */
export interface PlanPermissionCatalogLeaf {
  id: string;
  name: string;
  label: string;
}

/** Subgrupo do catálogo do plano (raw). */
export interface PlanPermissionCatalogSubgroup {
  key: string;
  label: string;
  permissions: PlanPermissionCatalogLeaf[];
}

/** Grupo do catálogo do plano (raw — id=nome da classe do controller no Core). */
export interface PlanPermissionCatalogGroup {
  id: string;
  name: string;
  subgroups: PlanPermissionCatalogSubgroup[];
}

export interface PlanPermissionCatalog {
  groups: PlanPermissionCatalogGroup[];
  selectedParamIds: string[];
  selectedGroupIds: string[];
}

export interface PlanPermissionSelection {
  plan: string;
  groupIds: string[];
  paramIds: string[];
}

@Injectable()
export class PlanPermissionService extends AbstractCrudService {
  private readonly EMPTY_PLAN_ID = '00000000-0000-0000-0000-000000000000';

  override title = 'Permissao de Grupo de Usuarios';
  override pluralTitle = 'Permissoes de Grupo de Usuarios';

  constructor(protected override httpClient: HttpClient) {
    super(httpClient, RELATIVE_URL);
  }

  public changeActives(objects: Object[]): Observable<void> {
    return this.httpClient.put<void>(
      `${API_PATH}${this.relativeUrl}/changeActives`,
      objects
    );
  }

  /**
   * Catálogo (3 níveis, own-only) + seleção atual do plano para o seletor unificado.
   * Schema-agnóstico no front: quem resolve a fonte (public/tenant) é a API.
   */
  public getCatalog(plan: string): Observable<PlanPermissionCatalog> {
    return this.httpClient.get<PlanPermissionCatalog>(
      `${API_PATH}${this.relativeUrl}/catalog`,
      { params: { plan } }
    );
  }

  /**
   * Árvore "Por tela" (front-first) com o universo COMPLETO do produto (plano é definição
   * comercial — sem own-only). Ids do tenant, os mesmos do Avançado.
   */
  public getFrontFirstTree(): Observable<FrontFirstTreeResponse> {
    return this.httpClient.get<FrontFirstTreeResponse>(
      `${API_PATH}${this.relativeUrl}/front-first-tree`
    );
  }

  /**
   * Grava a seleção: grupos cheios → vínculo dinâmico; parcial → granular.
   */
  public saveSelection(
    payload: PlanPermissionSelection
  ): Observable<PlanPermissionCatalog> {
    return this.httpClient.put<PlanPermissionCatalog>(
      `${API_PATH}${this.relativeUrl}/selection`,
      payload
    );
  }

  override listAll(params: any = {}): Observable<any> {
    const plan = params?.plan;

    if (!plan || plan === this.EMPTY_PLAN_ID) {
      return of([[], 0]);
    }

    return super.listAll(params);
  }
}
